
import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import { Stepper, Step, StepLabel, } from '@material-ui/core';
import PublicLayout from 'web/components/PublicLayout';
import { useDispatch, useSelector } from 'react-redux';
import { getRegisterInitialValues, getRegisterSchema, } from 'web/components/utils/corporateRegistrationUtils';

import AlertModal from 'web/components/AlertModal';

import Spinner from 'web/components/Spinner';
import Account from 'web/components/Account';
import FormContainer from 'web/components/FormContainer';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import EmailOTPVerification from './EmailVerification';
import { signUp, register } from 'redux/actions/register';
import StepOne from "web/assets/images/reg-step-one.webp";
import { fetchLanguageContentNew } from 'redux/actions/language';
import { RegistrationStepper, FormSection, ImageSection, RegistrationWraper, StepText, } from "web/pages/account/registration/corporate-Registration-Styled";
import { uploadSpecification } from 'redux/actions/postLoad';
import Layout from 'web/components/Layout';
import { getGuestUserBasicInfo, upgradeGuestSignup } from 'redux/actions/upgradeGuestMembership';
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const CorporateRegistration = (props) => {
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const [modalType, setModalType] = useState()
  const toggleModal = () => setModal(!modal);
  const validationSchemaArray = getRegisterSchema();

  const [driverLisenceArr, setDriverLisenceArr] = useState();
  const [driverLisenceImageStr, setDriverLisenceImageStr] = useState('');

  const [propState, setPropState] = useState('');
  const [taxidState, setTaxidState] = useState('0');
  const [step, setStep] = useState(0);
  let history = useHistory();
  const dispatch = useDispatch();
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()
  const [email, setEmail] = useState(false);
  const [referralDefault, setReferralDefault] = useState(false);
  const isGuestUserUpgrade = localStorage.getItem('guestUserUpgrade');
  const authToken = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    let token = localStorage.getItem('token')
    let isAdminOrUserAccount = localStorage.getItem('accountType')
    if (!isGuestUserUpgrade) {
      if (isAdminOrUserAccount && token) {
        if (isAdminOrUserAccount === 'Admin') history.push('/admin')
        else history.push('/dashboard')
      } else {
        dispatch(logoutAdmin())
        dispatch(logoutClearRedux())
        localStorage.clear()
        sessionStorage.clear()
      }
    }
  }, [])

  useEffect(() => {

    localStorage.removeItem('referralCode')
    localStorage.removeItem('promoCode')
    localStorage.removeItem('credtCardPaymentMethod')

    const { location } = props;
    const queryParams = new URLSearchParams(location.search)

    if (queryParams.get("referralCode")) {
      setReferralDefault(queryParams.get("referralCode"))
    }
    if (queryParams.get("email")) {
      setEmail(queryParams.get("email"))
    }
    if (languageContentNew?.Registration_Page) setPageLanguageContents(languageContentNew.Registration_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage))
    if (location.state) localStorage.setItem('formType', location.state.from);
    if (isGuestUserUpgrade) setStep(step + 1)

  }, []);

  //To get basic details (step-1) of logged-in guest user for upgrade account
  useEffect(() => {
    if (isGuestUserUpgrade && userId) {
      getBasicInfo()
    }
  }, [isGuestUserUpgrade, userId])

  const getBasicInfo = async () => {
    const response = await dispatch(getGuestUserBasicInfo(userId, authToken));
    if (response.data && response.data.status === 'SUCCESS') {
      localStorage.setItem('guestBasicInfo', JSON.stringify(response.data.payload ?? {}))
    } else {
      if (response && response.data && response.data.message === "Unauthorized (Invalid token)") {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent('Something went wrong');
        setModalLink("")
        toggleModal();
      }
    }
  }

  let registrationSteps
  if (localStorage.getItem('guestUser') === 'true') {
    registrationSteps = ['Guest User Registration']
  } else {
    registrationSteps = [pageLanguageContents?.Arrow[0]?.Arrow1_Basic, pageLanguageContents?.Arrow[1]?.Arrow2_Account, pageLanguageContents?.Arrow[2]?.Arrow3_Review]
  }

  const callSignUp = async (props, step) => {
    if (props.values.locationCity) {
      let data = {
        name: props.values.name,
        password: props.values.password,
        email: props.values.email,
        state: props.values.locationST,
        city: props.values.locationCity?.trim(),
        zipCode: props.values.locationZip,
        isOtpEnable: true,
        confirmPassword: props.values.confirmPassword,
        referralCode: props.values.referralCode
      };
      const response = await dispatch(signUp(data));
      if (response.data && response.data.status === 'SUCCESS') {
        setPropState(props.values)
        setStep('emailOtpVerification')
      } else {
        if (response && response.data && response.data.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          let indexVal = null
          if (pageLanguageContents?.Backend_Popups) {
            pageLanguageContents.Backend_Popups.forEach((val, index) => {
              if (Object.keys(val)[0] === response.data.message) {
                indexVal = index
              }
            })
          }
          if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][response.data.message])
          else setModalContent(response.data.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }
  const registerReview = async (props) => {
    const storedGuestBasicInfo = localStorage.getItem('guestBasicInfo');
    const guestBasicInfo = (storedGuestBasicInfo && storedGuestBasicInfo !== '')
      ? JSON.parse(storedGuestBasicInfo)
      : {};

    let setBuyer = (props.values?.buyerSellerOption === 'Buyer' || props.values?.buyerSellerOption === 'Buyer & Seller' || props.values?.reseller === 'active') ? true : false
    let setSeller = (props.values?.buyerSellerOption === 'Seller' || props.values?.buyerSellerOption === 'Buyer & Seller' || props.values?.reseller === 'active') ? true : false
    let reseller = props.values?.reseller === 'active' ? true : false

    let businessDesc = (
      (props.values?.businessDesc && props.values.businessDesc !== "") ||
      (guestBasicInfo?.businessDesc && guestBasicInfo.businessDesc !== "")
    ) ? (props.values?.businessDesc || guestBasicInfo?.businessDesc) : "NA";

    let businessURL = (props.values?.businessUrl !== "" && props.values?.businessUrl) || (guestBasicInfo?.businessUrl !== "" && guestBasicInfo?.businessUrl) || "NA";

    let diverseSpendSelectedListTemp
    if (props.values?.diverseSpendSelectedList && props.values?.diverseSpendSelectedList?.length > 0) {
      diverseSpendSelectedListTemp = props?.values?.diverseSpendSelectedList?.map(data => data.id)
    } else if (guestBasicInfo?.diverseSpendSelectedList && guestBasicInfo.diverseSpendSelectedList.length > 0) {
      diverseSpendSelectedListTemp = guestBasicInfo?.diverseSpendSelectedList?.map(data => data.id)
    }

    let data = {
      companyInfo: {
        taxId: props.values.taxId,
        dnbDuns: props.values.dnbNum,
        businessDesc: businessDesc,
        businessURL: businessURL,
        drivingLicense: [props.values.drivingLicense],
        dob: props.values.taxId && props.values.taxId !== '' ? null : props.values.dob,
        uploadImage: driverLisenceImageStr,
        firstName: props.values.firstName,
        lastName: props.values.lastName,
      },
      accountTypeDTO: {
        buyer: setBuyer,
        seller: setSeller,
        isReseller: reseller,
        accountType: 'CORPORATE_ADMIN'
      },
      subscriptionPaymentMethod: {
        payment_method: localStorage.getItem('paymentSubscription')
      },
      promoCodeId: localStorage.getItem('promoCode') ? localStorage.getItem('promoCode').toLowerCase() : null,
      referralCode: localStorage.getItem('referralCode') ? localStorage.getItem('referralCode') : null,
      buyerPaymentMethod: {
        payment_method: localStorage.getItem('credtCardPaymentMethod')
      },
      sellerPaymentMethod: {
        sellerTerm: 30,
        paymentToken: localStorage.getItem('debiCardPaymentMethod'),
        accountToken: localStorage.getItem('accountToken')
      },
      hearAbout: props.values.modeOfContact === 'Other' ? props.values.modeOfContactOther : props.values.modeOfContact
    };

    if (!isGuestUserUpgrade) {
      data.basicDetail = {
        name: props.values.name ? props.values.name?.trim() : props.values.name,
        registeredAddress: {
          line1: props.values.line1 ? props.values.line1?.trim() : props.values.line1,
          line2: props.values.line2 ? props.values.line2?.trim() : props.values.line2,
          state: props.values.locationST,
          city: props.values.locationCity ? props.values.locationCity?.trim() : props.values.locationCity,
          zip: props.values.locationZip
        },
        phoneNumber: props.values.smsPhNumber,
        companyName: props.values.companyName ? props.values.companyName?.trim() : props.values.companyName,
        email: props.values.email,
        dba: props.values.DBAName,
        diverseTracking: (diverseSpendSelectedListTemp && diverseSpendSelectedListTemp.length > 0) ? diverseSpendSelectedListTemp : null,
      }
    }

    let response = '';
    if (isGuestUserUpgrade) {
      data.email = localStorage.getItem('email') || guestBasicInfo?.email;
      response = await dispatch(upgradeGuestSignup(data, authToken));
    } else {
      response = await dispatch(register(data));
    }
    if (response.data.status === "SUCCESS") {
      let indexVal = null
      if (pageLanguageContents?.Backend_Popups) {
        pageLanguageContents.Backend_Popups.forEach((val, index) => {
          if (Object.keys(val)[0] === response.data.message) {
            indexVal = index
          }
        })
      }
      const approvalStatus = response?.data?.payload?.approvalStatus
      localStorage.setItem('approvalStatus', approvalStatus)
      setModalContent('Thank you for completing your registration. Your request has been sent to the PalletTrader Administration team for review. You will receive a confirmation email once your account has been activated.')
      if (localStorage.getItem('accountType') === "Guest" && localStorage.getItem('guestUserUpgrade')) {
        setModalLink('/dashboard');
      } else {
        setModalLink('/sign-in');
      }
      setModalType('registrationSuccess')
      toggleModal();
    } else {
      if (response.data.message === "Unauthorized (Invalid token)") {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        let indexVal = null
        if (pageLanguageContents?.Backend_Popups) {
          pageLanguageContents.Backend_Popups.forEach((val, index) => {
            if (Object.keys(val)[0] === response.data.message) {
              indexVal = index
            }
          })
        }
        if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][response.data.message])
        else setModalContent(response.data.message);
        setModalLink('');
        toggleModal();
      }
    }
  }
  const handleNext = async (props) => {
    setPropState(props.values)
    const { submitForm, validateForm, setTouched, isValid } = props
    submitForm().then(async () => {
      if (isValid) {
        setStep(1)
        window.scrollTo(0, 0);
        validateForm();
        setTouched({});
      }
    });
  }

  const handleNextFinalPaage = async (props, step, setFieldValue) => {
    setPropState(props.values)
    const { submitForm, validateForm, setTouched, isValid } = props
    if (!props.values.promoOrReferralValidated && props.values.promoCodeInput?.trim() !== '') {
      setModalContent("Please apply the promo/referral code, then submit.");
      setModalLink('');
      toggleModal();
      return
    } else {
      submitForm().then(async () => {
        if (props.values.drivingLicense && !driverLisenceArr) {
          setModalContent("Please upload driver's license first.");
          setModalLink('');
          toggleModal();
        } else {
          setStep(step + 1)
          window.scrollTo(0, 0);
          validateForm();
          setTouched({});
        }
      });
    }
  }

  const handleSubmit = (props) => {
    registerReview(props)
  };

  const handleBack = (props, step) => {
    const { setErrors } = props
    clearFields(props)
    setStep(step - 1)
    setErrors({});
  };

  const clearFields = (props) => {
    const { values, setFieldValue, isValid, dirty } = props;
    setFieldValue('buyerPaymentValidated', false)
    setFieldValue('sellerPaymentValidated', false)
    setFieldValue('membershipPaymentValidated', false)
    setFieldValue('buyerSellerOption', '')

    setFieldValue("accountHolderName", "");
    setFieldValue("bankRouting", "");
    setFieldValue("bankAccount", "");
    setFieldValue("promoCodeInput", "");

    setFieldValue("reseller", "");
    setFieldValue("seller", "");
    setFieldValue("buyer", "");
    setFieldValue("multipleLocations", "ONE");
    setFieldValue("locationType", "");
    setFieldValue("hybridOptions", "");

    setFieldValue("accountType", "");
    setFieldValue("buyerRadioType", "");
    setFieldValue("taxId", "");
    setFieldValue("drivingLicenseState", "");
    setFieldValue("dnbNum", "");
    setFieldValue("creditRef", "");
    setFieldValue("paymentTerm", "30");
    setFieldValue("taxidLicense", "");
    setFieldValue("drivingLicense", "");

    setFieldValue("ssn", "");
    setFieldValue("firstName", "");
    setFieldValue("lastName", "");
    setFieldValue("promoCodeChk", "");
    setFieldValue("promoCode", "");
    setFieldValue('appliedPromoCodeDetails', '')
  }

  const updateDriversLicenseImage = async (val) => {
    setDriverLisenceArr(val)
    let formData = new FormData();
    formData.append('uploadSpecification', val);
    let token = ''
    if (val !== undefined) {
      let response = await dispatch(uploadSpecification(formData, token));
      if (response.status === 'SUCCESS') {
        let value = response.payload
        if (value && value.length > 0) setDriverLisenceImageStr(value[0])
      }
    } else setDriverLisenceImageStr('')
  }

  // const withOutMemberShipModal =(props, setFieldValue)=>{    
  //   if (localStorage.getItem('memberShipType') !== undefined) {
  //     handleNext(props, setFieldValue)
  //     if (localStorage.getItem('memberShipType') === 'broker') setFieldValue('reseller', 'active')
  //     else if (localStorage.getItem('memberShipType') === 'buyerSeller') {
  //       setFieldValue('reseller', 'deActive')
  //       setFieldValue('buyerSellerOption', 'Buyer & Seller')
  //     }
  //   }
  // }
  // // : <>{withOutMemberShipModal(props, setFieldValue)}</>}&& localStorage.getItem('postInventory') ==="false"

  return (
    <>
      <Helmet
        title="Unlock Membership - Sign Up for an Account on PalletTrader Now | PalletTrader">
        <meta name="description"
          content="Unlock Membership - Sign up for an account on PalletTrader now. Gain exclusive access to trading tools and resources. Join us today and elevate your trading experience!" />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/registration" />
      </Helmet>
      {
        !isGuestUserUpgrade &&
        <PublicLayout transparentHeader={true}>
          {step !== 'emailOtpVerification' &&
            <RegistrationStepper>
              <Stepper activeStep={step} variant="elevation">
                {registrationSteps.map((label, index) => (
                  <Step key={label}>
                    <StepLabel>
                      {localStorage.getItem('guestUser') === "false" && <span className="step-number">{index + 1}</span>}
                      <StepText>
                        <span>{label}</span>
                      </StepText>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </RegistrationStepper>
          }
          <Account>
            <ImageSection>
              <img src={StepOne} alt="" />
            </ImageSection>
            <FormContainer>
              <FormSection>
                {loaderVisible && <Spinner />}
                <RegistrationWraper>
                  <Formik
                    validateOnMount
                    enableReinitialize={true}
                    initialValues={getRegisterInitialValues(email, referralDefault)}
                    validationSchema={validationSchemaArray[step === 'emailOtpVerification' ? 0 : step](
                      propState,
                      taxidState,
                      pageLanguageContents
                    )}
                    onSubmit={(values) => { }}
                  >
                    {(props) => {
                      const { values, setFieldValue, isValid, dirty } = props;
                      return (
                        <Form className="form">
                          {step === 0 && (
                            <Step1
                              setFieldValue={setFieldValue}
                              email={email}
                              isValid={isValid}
                              dirty={dirty}
                              props={props}
                              submitCallBack={(promoFlag) => {
                                callSignUp(props, step);
                              }}
                              pageLanguageContents={pageLanguageContents}
                            />
                          )}

                          {step === 'emailOtpVerification' && (
                            <EmailOTPVerification
                              props={props}
                              onSuccessHandler={(val) => {
                                if (val !== undefined) {
                                  handleNext(props, setFieldValue)
                                  if (val === 'broker') setFieldValue('reseller', 'active')
                                  else if (val === 'buyerSeller') {
                                    setFieldValue('reseller', 'deActive')
                                    setFieldValue('buyerSellerOption', 'Buyer & Seller')
                                  }
                                }
                              }} />
                          )}

                          {step === 1 && (
                            <Step2
                              props={props}
                              setFieldValue={setFieldValue}
                              callBackFun={(e, yesNoValue) => {
                                setPropState(props.values)
                              }}
                              nextCallBack={() => {
                                handleNextFinalPaage(props, step, setFieldValue);
                              }}
                              pageLanguageContents={pageLanguageContents}

                              uploadDriverLisence={(val) => updateDriversLicenseImage(val)}
                              setTaxIdState={(val) => setTaxidState(val)}
                            />
                          )}

                          {/* Third page (review and submit) */}
                          {step === 2 && (
                            <Step3
                              props={props}
                              backBtnCallBack={() => {
                                setFieldValue("locationCharge", false);
                                setFieldValue("authorize", false);
                                localStorage.setItem('buyerDebitCardNumber', '');
                                localStorage.setItem('sellerDebitCardNumber', '');
                                handleBack(props, step);
                              }}
                              submitCallBack={() => {
                                handleSubmit(props);
                              }}
                              pageLanguageContents={pageLanguageContents}
                            />
                          )}
                          <div>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>

                  <AlertModal
                    isOpen={modal}
                    toggle={toggleModal}
                    title=""
                    content={modalContent}
                    link={modalLink}
                  />


                </RegistrationWraper>
              </FormSection>
            </FormContainer>
          </Account>
        </PublicLayout>
      }
      {
        isGuestUserUpgrade &&
        <Layout transparentHeader={false} topBarViewMobile={"hide"}>

          <Account>
            <ImageSection>
              <img src={StepOne} alt="" />
            </ImageSection>
            <FormContainer>
              <FormSection>
                {loaderVisible && <Spinner />}
                {step === 1 && <h6 style={{ fontFamily: 'latobold' }}>Complete the form below to become a Member.</h6>}
                {step === 2 && <h6 style={{ fontFamily: 'latobold' }}>Review Account Details.</h6>}
                <RegistrationWraper>
                  <Formik
                    validateOnMount
                    enableReinitialize={true}
                    initialValues={getRegisterInitialValues(email, referralDefault)}
                    validationSchema={validationSchemaArray[step](
                      propState,
                      taxidState,
                      pageLanguageContents
                    )}
                    onSubmit={(values) => { }}
                  >
                    {(props) => {
                      const { values, setFieldValue, isValid, dirty } = props;
                      return (
                        <Form className="form">

                          {step === 1 && (
                            <Step2
                              props={props}
                              setFieldValue={setFieldValue}
                              callBackFun={(e, yesNoValue) => {
                                setPropState(props.values)
                              }}
                              nextCallBack={() => {
                                handleNextFinalPaage(props, step, setFieldValue);
                              }}
                              pageLanguageContents={pageLanguageContents}
                              uploadDriverLisence={(val) => updateDriversLicenseImage(val)}
                              setTaxIdState={(val) => setTaxidState(val)}
                            />
                          )}

                          {/* Third page (review and submit) */}
                          {step === 2 && (
                            <Step3
                              props={props}
                              backBtnCallBack={() => {
                                setFieldValue("locationCharge", false);
                                setFieldValue("authorize", false);
                                localStorage.setItem("sellerDebitCardNumber", '')
                                localStorage.setItem("sellerDebitCardName", '')
                                localStorage.setItem("creditCardNumber", '')
                                localStorage.setItem("creditCardName", '')
                                localStorage.setItem("buyerDebitCardNumber", '')
                                localStorage.setItem("buyerDebitCardName", '')
                                handleBack(props, step);
                              }}
                              submitCallBack={() => {
                                handleSubmit(props);
                              }}
                              pageLanguageContents={pageLanguageContents}
                            />
                          )}
                          <div>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>

                  <AlertModal
                    isOpen={modal}
                    toggle={toggleModal}
                    title=""
                    content={modalContent}
                    link={modalLink}
                    alertType='success'
                    callBackAlert={() => {
                      if (modalType === 'registrationSuccess') {
                        setModalType()
                        //remove card details from local storage
                        localStorage.removeItem('guestBasicInfo')
                        localStorage.removeItem("sellerDebitCardNumber")
                        localStorage.removeItem("sellerDebitCardName")
                        localStorage.removeItem("creditCardNumber")
                        localStorage.removeItem("creditCardName")
                        localStorage.removeItem("buyerDebitCardNumber")
                        localStorage.removeItem("buyerDebitCardName")
                        localStorage.removeItem("promoCode")
                      }
                    }}
                  />
                </RegistrationWraper>
              </FormSection>
            </FormContainer>
          </Account>
        </Layout>
      }
    </>
  );
};
export default CorporateRegistration;